import React from "react";

import AppBar from "@mui/material/AppBar";
import kantarLogo from "./kantar-logo-white.png";
import { useTheme } from "@mui/material/styles";
import styled from "@emotion/styled";

function Navigation() {
  const theme = useTheme();
  return (
    <AppBar position="static" sx={{ backgroundColor: theme.palette.blackish.main }}>
      <PaddedDiv>
        <img src={kantarLogo} alt="The Kantar Logo" style={{ height: "2rem" }} />
      </PaddedDiv>
    </AppBar>
  );
}

const PaddedDiv = styled.div`
  padding: min(8vw, 5.625rem);
`;

export default Navigation;
